import styles from "./styles.module.css";

import React from 'react';
import { ModuleProps } from "components/props/ModuleProps"
import { IconPicker } from "components/layout/icons/IconPicker";
import parse from 'html-react-parser';
import { ResponsiveContent } from "components/layout/ResponsiveContent";
import { ModuleOnline } from "./ModuleOnline";

interface ModuleDefaultProps {
    module: ModuleProps;
    onClick: (module: ModuleProps) => void;
}
const ModuleDefault = (props:ModuleDefaultProps) => {

    return (
        <ModuleOnline module={props.module}>
            <div className={styles.bar} onClick={() => props.onClick(props.module)}>
                <div className={styles.barContent}>
                    <div role="heading">{parse(props.module.text)}</div>
                    <div><IconPicker icon={props.module.icon} size={24} /></div>
                </div>
                {
                    (props.module.minWidth) &&
                    <ResponsiveContent minWidth={props.module.minWidth}>Krever en bredde p&aring; mer enn 768px.</ResponsiveContent>
                }
            </div>
        </ModuleOnline>
    )
}

export default ModuleDefault;
